var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgGuidelinesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8592 7.98433H4.60797C2.58147 7.98433 0.923096 6.32595 0.923096 4.29945C0.923096 2.27385 2.58147 0.615479 4.60797 0.615479H19.8592C21.8857 0.615479 23.5441 2.27385 23.5441 4.29945C23.5441 6.32595 21.8857 7.98433 19.8592 7.98433Z",
    fill: "#DD5546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60786 1.15383C2.87865 1.15383 1.46144 2.57121 1.46144 4.29934C1.46144 6.02846 2.87874 7.44575 4.60786 7.44575H19.8591C21.5883 7.44575 23.0056 6.02846 23.0056 4.29934C23.0056 2.57121 21.5883 1.15383 19.8591 1.15383H4.60786ZM0.384521 4.29934C0.384521 1.97627 2.28406 0.0769043 4.60786 0.0769043H19.8591C22.1829 0.0769043 24.0825 1.97627 24.0825 4.29934C24.0825 6.62323 22.183 8.52268 19.8591 8.52268H4.60786C2.28397 8.52268 0.384521 6.62323 0.384521 4.29934Z",
    fill: "#06162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5177 16.5372C27.5177 18.9031 25.5998 20.8209 23.2339 20.8209C20.8681 20.8209 18.9502 18.9031 18.9502 16.5372C18.9502 14.1713 20.8681 12.2534 23.2339 12.2534C25.5998 12.2534 27.5177 14.1713 27.5177 16.5372Z",
    fill: "#EFF7FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2341 12.792C21.1656 12.792 19.4888 14.4688 19.4888 16.5373C19.4888 18.6058 21.1656 20.2826 23.2341 20.2826C25.3026 20.2826 26.9794 18.6058 26.9794 16.5373C26.9794 14.4688 25.3026 12.792 23.2341 12.792ZM18.4119 16.5373C18.4119 13.874 20.5708 11.7151 23.2341 11.7151C25.8974 11.7151 28.0563 13.874 28.0563 16.5373C28.0563 19.2006 25.8974 21.3595 23.2341 21.3595C20.5708 21.3595 18.4119 19.2006 18.4119 16.5373Z",
    fill: "#06162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8865 27.1009C18.8865 29.4668 16.9687 31.3846 14.6028 31.3846C12.236 31.3846 10.3181 29.4668 10.3181 27.1009C10.3181 24.735 12.236 22.8171 14.6028 22.8171C16.9687 22.8171 18.8865 24.735 18.8865 27.1009Z",
    fill: "#7EE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6029 23.3555C12.5334 23.3555 10.8567 25.0323 10.8567 27.1008C10.8567 29.1692 12.5334 30.8461 14.6029 30.8461C16.6714 30.8461 18.3482 29.1693 18.3482 27.1008C18.3482 25.0323 16.6714 23.3555 14.6029 23.3555ZM9.77979 27.1008C9.77979 24.4374 11.9388 22.2786 14.6029 22.2786C17.2662 22.2786 19.4251 24.4375 19.4251 27.1008C19.4251 29.7641 17.2662 31.923 14.6029 31.923C11.9388 31.923 9.77979 29.7641 9.77979 27.1008Z",
    fill: "#06162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5899 16.5263L6.08171 12.0181L1.57349 16.5263L6.08171 21.0345L10.5899 16.5263Z",
    fill: "#0093C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70085 11.6374C5.91113 11.4272 6.25206 11.4272 6.46235 11.6374L10.9706 16.1457C11.1809 16.356 11.1809 16.6969 10.9706 16.9072L6.46235 21.4154C6.25206 21.6257 5.91113 21.6257 5.70085 21.4154L1.19262 16.9072C0.982342 16.6969 0.982342 16.356 1.19262 16.1457L5.70085 11.6374ZM2.33487 16.5264L6.0816 20.2731L9.82832 16.5264L6.0816 12.7797L2.33487 16.5264Z",
    fill: "#06162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4118 17.0221H10.759V16.0305H11.4118V17.0221Z",
    fill: "#06162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2383 17.0647H12.6829V15.9878H13.2383V17.0647ZM15.4601 17.0647H14.3492V15.9878H15.4601V17.0647ZM17.1264 17.0647H16.571V15.9878H17.1264V17.0647Z",
    fill: "#06162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4987 16.9915H17.8459V16H18.4987V16.9915Z",
    fill: "#06162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54321 27.0291V21.0349H6.62014V26.4907H9.9982V27.5676H6.08167C5.78429 27.5676 5.54321 27.3265 5.54321 27.0291Z",
    fill: "#06162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.62062 7.84937V12.0182H5.5437V7.84937H6.62062Z",
    fill: "#06162D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidelinesIcon);
export default __webpack_public_path__ + "static/media/guidelines_icon.569c918bf1c110c55009904ceec93c29.svg";
export { ForwardRef as ReactComponent };